import { useState } from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import PathsSection from "../components/PathsSection";
import MarqueeBand from "../components/MarqueeBand";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import CalendlyModal from "../components/CalendlyModal";
import CookieBanner from "../components/CookieBanner";

export default function Landing() {
    const [calendlyOpen, setCalendlyOpen] = useState(false);
    const open = () => setCalendlyOpen(true);

    return (
        <div id="top" className="relative bg-powder text-ink overflow-hidden">
            <div className="grain-overlay" />
            <Nav onBook={open} />
            <main>
                <Hero onBook={open} />
                <PathsSection />
                <MarqueeBand />
                <Testimonials onBook={open} />
                <Contact onBook={open} />
            </main>
            <Footer onBook={open} />
            <CalendlyModal open={calendlyOpen} onOpenChange={setCalendlyOpen} />
            <CookieBanner />
        </div>
    );
}
